import type { StaticPage } from "../types/staticPages";

export function useStaticPage() {
   const { catcher } = useErrorHelper();
   const { logInfo, logError } = useDebugger();
   // const hook = useNuxtApp().hook;
   const $apiFetch = useNuxtApp().$apiFetch as typeof $fetch;

   // STATE
   const page = useState<StaticPage.Page>(
      "page",
      () => ({} as StaticPage.Page)
   );

   const getPage = computed((): StaticPage.Page => {
      return page.value;
   });

   const setPage = (data: StaticPage.Page): void => {
      page.value = data;
   };

   // QUERY
   const queryStaticPageSlugs = async (): Promise<StaticPage.SlugsResponse> => {
      return await $apiFetch<StaticPage.SlugsResponse>(`page/static-slugs`)
         .then((res) => res ?? [])
         .catch((error) => {
            logError(error);
            return [];
         });
   };

   const queryStaticPage = async (
      slug: string,
      school?: string,
   ): Promise<StaticPage.Page | undefined> => {
      page.value = {} as StaticPage.Page;
      return await $apiFetch<StaticPage.Page>(`page/static/${slug}`, {
         params: school ? { school: school } : {},
      })
         .then((data) => {
            logInfo(`queryStaticPage - ${slug}`, data);
            page.value = data;
            return data;
         })
         .catch((error) => {
            logError(error);
            return undefined;
         });
   };

   return {
      page,
      getPage,
      setPage,
      queryStaticPage,
      queryStaticPageSlugs,
   };
}
